export default {
  SET_WHITELISTS: (state, data) => {
    state.whitelists = data || []
  },
  SET_WHITELIST: (state, data) => {
    state.whitelist = data
  },
  SET_NAME: (state, data) => { state.whitelist.name = data },
  UPDATE_ISLOADING: (state, data) => { state.isLoading = data },
  CLEAR_WHITELISTS: state => { state.whitelists = [] },

  SET_PAGINATION: (state, data) => { const { items, ...p } = data; state.pagination = p },

  UPDATE_FILTER: (state, data) => {
    state.filters.params[data.propKey] = data.value
  },
  RESET_FILTER: state => {
    const filteri = {
      params: {
        page: 1,
        take: 10,
        search: '',
        order: 'desc',
      },
    }
    state.filters = filteri
  },
}
